<div class="lp-inventory-item-modal" style="position: relative">
  <app-style-sheet-sprite [sprite]="_stylesService.INVENTORY_PANEL()?.container" [text]="_stylesService.INVENTORY_PANEL()?.text">
    <div style="height: 100%; overflow-y: auto">
      <div class="lp-inventory-item-preview" style="display: grid; grid-template-rows: max-content 1fr; text-align: center; height: 100%">
        <div>
          <img [src]="item().icon.url" style="width: 100%; aspect-ratio: 1; object-fit: contain" />
        </div>
        <h2 style="font-size: 2em; place-content: center">{{ item().displayName }}</h2>
      </div>

      <lp-inventory-item-content [contents]="item().contentElements" />
    </div>
  </app-style-sheet-sprite>
  <app-hud-icon-button
    style="display: block; position: absolute; top: -1em; right: -1em; width: 3em; height: 3em"
    [icon]="_stylesService.SPRITE_ICON_CROSS()?.container"
    (click)="closed.emit()"
    @modal
  />
</div>
